import { postAPIPayload } from "../../apis/postApi";
import { buildCarPaymentSession, CAR_SKIP_OWNER_PIN } from "./carInEscrowSignup";

export {
  CAR_SKIP_OWNER_PIN,
  buildCarPaymentSession,
  carClosingPayer,
  carClosingPayerTag,
  carPortfolioAction,
  rememberCarInEscrowPinSkip,
  shouldSkipCarOwnerPin,
  skipCarOwnerVerifiedPage,
} from "./carInEscrowSignup";

// The existing client an agent is adding another property for (card 3854).
const ADD_PROPERTY_CLIENT_KEY = "car_add_property_client";

export const clearCarEnrollmentSession = () => {
  localStorage.removeItem("car_portfolio_id");
  localStorage.removeItem("car_portfolio_ids");
  localStorage.removeItem("carEnrollment");
  localStorage.removeItem("carPortfolioPrefill");
  localStorage.removeItem(ADD_PROPERTY_CLIENT_KEY);
  sessionStorage.removeItem(CAR_SKIP_OWNER_PIN);
};

// Add Property runs the same steps as adding a client, for this client.
export const carAddPropertyPath = (clientUserId) =>
  `/clients/create?add_for=${encodeURIComponent(clientUserId)}`;

export const rememberCarAddPropertyClient = (clientUserId) => {
  localStorage.setItem(ADD_PROPERTY_CLIENT_KEY, String(clientUserId));
};

export const isCarAddPropertyClient = (clientUserId) =>
  Boolean(clientUserId) &&
  localStorage.getItem(ADD_PROPERTY_CLIENT_KEY) === String(clientUserId);

export const readCarPortfolioIds = () => {
  try {
    const raw = localStorage.getItem("car_portfolio_ids");
    const parsed = raw ? JSON.parse(raw) : [];
    if (Array.isArray(parsed) && parsed.length) {
      return parsed.map(Number).filter(Boolean);
    }
  } catch {
    // fall through to the single id
  }
  const one = Number(localStorage.getItem("car_portfolio_id"));
  return one ? [one] : [];
};

export const rememberCarPayment = (row) => {
  if (!row?.id) return;
  rememberCarPortfolioIds([row.id]);
  const session = buildCarPaymentSession(row);
  localStorage.setItem("carEnrollment", JSON.stringify(session.enrollment));
  localStorage.setItem("carPortfolioPrefill", JSON.stringify(session.prefill));
};

export const rememberCarPortfolioIds = (ids) => {
  const clean = (Array.isArray(ids) ? ids : [ids]).map(Number).filter(Boolean);
  if (!clean.length) return;
  localStorage.setItem("car_portfolio_id", String(clean[0]));
  localStorage.setItem("car_portfolio_ids", JSON.stringify(clean));
  localStorage.setItem("signup_source", "car");
};

export const advanceCarPortfolio = (status) => {
  const ids = readCarPortfolioIds();
  if (!ids.length || !status) {
    return Promise.resolve(null);
  }

  return Promise.all(
    ids.map((portfolioId) =>
      postAPIPayload({
        url: `service-provider/car-portfolio/${portfolioId}/advance`,
        data: { status },
        token: true,
      }),
    ),
  );
};

export const resendCarOwnerInvite = (portfolioId) =>
  postAPIPayload({
    url: `service-provider/car-portfolio/${portfolioId}/resend-owner-invite`,
    data: {},
    token: true,
  });

export const declineCarPortfolio = async (portfolioId) => {
  const response = await postAPIPayload({
    url: `service-provider/car-portfolio/${portfolioId}/advance`,
    data: { status: "declined" },
    token: true,
  });
  if (
    response?.success &&
    String(localStorage.getItem("car_portfolio_id") || "") === String(portfolioId)
  ) {
    clearCarEnrollmentSession();
  }
  return response;
};
